<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Doctors </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Doctor List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-success float-right" style="margin-left: 7px;" @click="toggleImportModal">
                                <i class="fas fa-plus"></i> Bulk Add Doctors
                            </button> -->
                            <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">   
                            <Datatable 
                                :columns="columns" 
                                :sortKey="tableData.sortKey"  
                                @sort="sortBy" 
                                v-if="!loading">
                                <template #header > 
                                    <div class="tableFilters" style="margin-bottom: 10px;">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="control" style="float: left;">
                                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                    <div class="select" style="float: left;">
                                                        <select class="form-select" v-model="tableData.length" @change="getDoctorList()"> 
                                                            <option value="10" selected="selected">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option :value="pagination.total">All</option>
                                                        </select>
                                                    </div>
                                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-2">
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getDoctorList()">
                                            </div>
                                        </div>
                                    </div>   
                                </template> 
                                <template #body >                            
                                    <tbody v-if="doctors.length > 0">
                                        <tr class=" " v-for="(item, i) in doctors" :key="i">
                                            <td>{{ i + 1 }} </td> 
                                            <td>{{ item.doctor_code }} </td> 
                                            <td>{{ item.first_name +' '+ item.last_name }} </td> 
                                            <td>{{ item.phone }} </td>
                                            <td>{{ item.email }}</td>
                                            <td>{{ item.specialist }}</td>
                                            <td>{{ item.department_name }}</td> 
                                            <td>
                                                <div class="dropdown float-end">
                                                    <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="mdi mdi-dots-vertical"></i>
                                                    </a>
                                                    <div class="dropdown-menu dropdown-menu-end">
                                                        <!-- item-->
                                                        <a href="#" @click="show(item)" class="dropdown-item text-info"><i class="fa-solid fa-eye"></i> View</a> 
                                                        <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)">
                                                        <i class="mdi mdi-circle-edit-outline me-1"></i>Edit</a>
                                                        <!-- item-->
                                                        <a href="javascript:void(0);" class="dropdown-item text-danger" @click="deleteItem(item)"><i class="mdi mdi-delete-outline me-1"></i>Remove</a>
                                                    </div>
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody> 
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="3"> No Data Available Here!</td>
                                        </tr>
                                    </tbody>
                                </template> 
                                <template #footer>
                                    <Pagination 
                                        :pagination="pagination"  
                                        :language="lang"
                                        @onChangePage="setPage" > 
                                    </Pagination> 
                                </template> 
                            </Datatable>


                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>Doctor Create</h3>
                        <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                    </div>
                    <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row  ">
                                        <!-- <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="doctor_code">Doctor Code *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('doctor_code')" v-model="form.doctor_code" id="doctor_code" placeholder="Doctor Code" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.doctor_code">
                                                    {{errors.doctor_code[0]}}
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="company_id">Company *</label> 
                                                <select class="form-control border" v-model="form.company_id" @change="onkeyPress('company_id')" id="company_id">
                                                    <option value="0">Select company</option>
                                                    <option v-for="(company, index) in companies" :value="company.id" :key="index">
                                                        {{company.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.company_id">
                                                    {{errors.company_id[0]}}
                                                </div>
                                            </div>
                                        </div> 

                                        <div class="form-group col-md-6">
                                            <label for="department_id" style="float: none;">Doctor Department *</label> 
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.department_id"
                                                placeholder="Select Department"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="departments"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />   
                                            <div class="invalid-feedback" v-if="errors.department_id">
                                                {{errors.department_id[0]}}
                                            </div>
                                        </div> 
                                    </div>

                                    <div class="row ">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="first_name">First Name *</label>
                                                <input type="text" class="form-control border"  @keypress="onkeyPress('first_name')" @keyup="ledgerAccountNameSetup($event.target.value)" v-model="form.first_name" id="first_name" placeholder="First Name" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.first_name">
                                                    {{errors.first_name[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="last_name">Last Name *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('last_name')" v-model="form.last_name" id="last_name" placeholder="Last Name" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.last_name">
                                                    {{errors.last_name[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="email">Email *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('email')" v-model="form.email" id="email" placeholder="Doctor Email" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.email">
                                                    {{errors.email[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="phone">Phone *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('phone')" v-model="form.phone" id="phone" placeholder="Doctor mobile number"> 
                                                <div class="invalid-feedback" v-if="errors.phone">
                                                    {{errors.phone[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="designation">Designation *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('designation')" v-model="form.designation" id="designation" placeholder="Designation"> 
                                                <div class="invalid-feedback" v-if="errors.designation">
                                                    {{errors.designation[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="qualification">Qualification *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('qualification')" v-model="form.qualification" id="qualification" placeholder="Qualification"> 
                                                <div class="invalid-feedback" v-if="errors.qualification">
                                                    {{errors.qualification[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="specialist">Specialist *</label>
                                                    <input type="text" class="form-control border" @keypress="onkeyPress('specialist')" v-model="form.specialist" id="specialist" placeholder="Specialist"> 
                                                    <div class="invalid-feedback" v-if="errors.specialist">
                                                        {{errors.specialist[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="row">
                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="dob">Date of Birth </label>
                                                        <input type="date" class="form-control border " @keypress="onkeyPress('dob')" v-model="form.dob" id="dob" placeholder="" autocomplete="off"> 
                                                        <div class="invalid-feedback" v-if="errors.dob">
                                                            {{errors.dob[0]}}
                                                        </div>
                                                    </div>
                                                </div> 

                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="blood_group">Blood Group </label> 
                                                        <select class="form-control border" v-model="form.blood_group" @change="onkeyPress('blood_group')" id="blood_group">
                                                            <option value="null" selected>Select Blood Group</option>
                                                            <option value="A+">A+</option>
                                                            <option value="A-">A-</option>
                                                            <option value="AB+">AB+</option>
                                                            <option value="AB-">AB-</option>
                                                            <option value="B+">B+</option>
                                                            <option value="B-">B-</option>
                                                            <option value="O+">O+</option>
                                                            <option value="O-">O-</option>

                                                        </select> 
                                                        <div class="invalid-feedback" v-if="errors.blood_group">
                                                            {{errors.blood_group[0]}}
                                                        </div>
                                                    </div>
                                                </div> 

                                                
                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="gender">Gender *</label>
                                                        <select class="form-control border" v-model="form.gender" @change="onkeyPress('gender')">
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                        </select>
                                                        <div class="invalid-feedback" v-if="errors.gender">
                                                            {{errors.gender[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <div class="mb-3">
                                                <label for="status">Status *</label>
                                                <select class="form-control border" v-model="form.status" @change="onkeyPress('status')">
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.status">
                                                    {{errors.status[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-3"> 
                                            <div class="mb-3" style="text-align: right;">
                                                <label for="create_user" style="width: 100%">&nbsp;&nbsp;</label>
                                                <input type="checkbox" class="form-check-input border " @change="onkeyPress('create_user')" true-value="1" false-value="0" v-model="form.create_user" id="create_user"><b> Create User</b>
                                                <div class="invalid-feedback" v-if="errors.create_user">
                                                    {{errors.create_user[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-3" v-if="form.create_user == 1"> 
                                            <div class="mb-3">
                                                <label for="password">Password *</label>
                                                <input type="password" class="form-control border" @keypress="onkeyPress('password')" v-model="form.password" id="password" placeholder="Password" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.password">
                                                    {{errors.password[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-3" v-if="form.create_user == 1"> 
                                            <div class="mb-3">
                                                <label for="password_confirmation">Confirm Password *</label>
                                                <input type="password" class="form-control border" @keypress="onkeyPress('password_confirmation')" v-model="form.password_confirmation" id="password_confirmation" placeholder="Confirm Password" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.password_confirmation">
                                                    {{errors.password_confirmation[0]}}
                                                </div>
                                            </div>
                                        </div>                                    
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <div class="mb-3">
                                                <label for="commission_percentage">Commission Percent</label> 
                                                <input type="number" class="form-control" @keypress="onkeyPress('commission_percentage')" v-model="form.commission_percentage" id="commission_percentage" placeholder="Commission Percent" autocomplete="off">
                                                <div class="invalid-feedback" v-if="errors.commission_percentage">
                                                    {{errors.commission_percentage[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6"> 
                                            <div class="mb-3">
                                                <label for="description">Description</label>
                                                <textarea class="form-control border" @keypress="onkeyPress('description')" v-model="form.description" id="description" placeholder="Description" autocomplete="off"></textarea> 
                                                <div class="invalid-feedback" v-if="errors.description">
                                                    {{errors.description[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-3">
                                            <div class="form-group">
                                                <label style="width: 100%">Image (128X128)</label> <br>
                                                <div class="fileinput fileinput-new" data-provides="fileinput" style="position: relative;">
                                                <span class="btn btn-block btn-primary btn-file"><span class="fileinput-new"><i class="fa fa-camera"></i> Chose Image</span>
                                                <span class="fileinput-exists" style="display:none">Change Image</span><input type="file" name="..." @change="onImageChange"/></span>
                                                </div> 
                                                <div class="invalid-feedback" v-if="errors.dimage">
                                                    {{errors.dimage[0]}}
                                                </div>

                                                <img :src="imagePreview" v-if="form.dimage" width="200" >
                                                <div v-if="editMode & !imagePreview">
                                                    <img :src="form.dimage" v-if="form.dimage" width="200">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Address Details </label>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="address_primary">Address 1</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('address_primary')" v-model="form.address_primary" id="address_primary" placeholder="Address 1"> 
                                                <div class="invalid-feedback" v-if="errors.address_primary">
                                                    {{errors.address_primary[0]}}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="address_secondary">Address 2</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('address_secondary')" v-model="form.address_secondary" id="address_secondary" placeholder="Address 2"> 
                                                <div class="invalid-feedback" v-if="errors.address_secondary">
                                                    {{errors.address_secondary[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="row">  
                                        <div class="form-group col-md-4">
                                            <div class="mb-3"> 
                                                <label for="district_id">District</label>
                                                <select class="form-control border" v-model="form.district_id" @change="onkeyPress('district_id')" id="district_id">
                                                    <option value="0">Select district</option>
                                                    <option v-for="(district, index) in districts" :value="district.id" :key="index"> {{district.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.district_id">
                                                    {{errors.district_id[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <div class="mb-3"> 
                                                <label for="area_id">Area</label>
                                                <select class="form-control border" v-model="form.area_id" @change="onkeyPress('area_id')" id="district_id">
                                                    <option value="0">Select area </option>
                                                    <option v-for="(area, index) in areas" :value="area.id" :key="index"> {{area.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.area_id">
                                                    {{errors.area_id[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <div class="mb-3"> 
                                                <label for="postal_code">Postal Code</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('postal_code')" v-model="form.postal_code" id="postal_code" placeholder="Postal Code" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.postal_code">
                                                    {{errors.postal_code[0]}}
                                                </div>
                                            </div>
                                        </div>
                                         
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Social Details</label>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="facebook_url">Facebook URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('facebook_url')" v-model="form.facebook_url" id="facebook_url" placeholder="Facebook URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.facebook_url">
                                                    {{errors.facebook_url[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="twitter_url">Twitter URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('twitter_url')" v-model="form.twitter_url" id="twitter_url" placeholder="Twitter URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.twitter_url">
                                                    {{errors.twitter_url[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="instagram_url">Instagram URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('instagram_url')" v-model="form.instagram_url" id="instagram_url" placeholder="Instagram URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.instagram_url">
                                                    {{errors.instagram_url[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="linkedin_url">Linkedin URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('linkedin_url')" v-model="form.linkedin_url" id="linkedin_url" placeholder="Linkedin URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.linkedin_url">
                                                    {{errors.linkedin_url[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                    </div>                                    

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Account Ledger Setup *</label>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="doctor_commission_account">Doctor Commission Account Ledger *</label>
                                            <input type="text" class="form-control border " @keypress="onkeyPress('doctor_commission_account')" v-model="form.doctor_commission_account" id="doctor_commission_account" placeholder="Doctor Commission Account"> 
                                            <div class="invalid-feedback" v-if="errors.doctor_commission_account">
                                                {{errors.doctor_commission_account[0]}}
                                            </div>
                                        </div>
                                    </div>

                                </div> 
                            </div>
                        </div>
                        <div class="modal-footer"> 
                            <button type="button" class="btn btn-danger" @click="toggleModal()">
                                Close
                            </button> 
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span>{{btn}} 
                            </button> 
                        </div>
                    </form>
                </div>
            </Modal>

            <!--Bulk Add Customer Modal -->
            <Modal @close="toggleImportModal" :modalActive="importModal">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <button @click="toggleImportModal" type="button" class="btn btn-default">X</button>
                        <h5 style="text-align: right">Import Customers</h5>
                    </div>

                    <div class="modal-body">  
                        <div class="row">
                            <div class="col-md-12">
                                <form role="form" @submit.prevent="submitImportForm()" enctype="multipart/form-data">
                                    <p style="font-size: 13px; font-style: italic;">The field labels marked with * are required input fields.</p>
                                    <p style="font-size: 16px;">The correct column order is (patient_code*, name*, email, phone*, address*, dob, patient_group*, company) and you must follow this.</p>
                                    <p style="font-size: 16px;">Patient Code and Phone both field data must be unique.</p>
                                    <p style="font-size: 16px;">Patient Group and Company Must be enlisted Before Customer Add (if don't have)</p>
                                    
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="mb-3">
                                                <label for="excel_file"> Upload EXCEL File *</label>
                                                <input type="file" class="form-control" id="excel_file" ref="file" name="..." @change="customerImportFile(), onkeyPress('excel_file')">
                                                
                                                <div class="invalid-feedback" v-if="errors">
                                                    <p v-for="(error, i) in errors" :key="i">{{ error[0] }}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="mb-3">
                                                <label> Sample File</label>
                                                <a :href="samplefile_url" class="btn btn-info" style="display: block; width: 100%; clear:both;" download><i class="fas fa-download"></i> Download</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <button type="submit" class="btn btn-primary" :disabled="disabled_upload">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <!-- Doctor Profile Modal -->
            <Modal @close="toggleProfileModal()" :modalActive="modalShow">
                <div class="modal-content scrollbar-width-thin doctor-show-modal">
                    <div class="modal-header"> 
                        <h5 class="">Details Info</h5>
                        <button @click="toggleProfileModal" type="button" class="btn btn-default">X</button>
                    </div>
                    <div class="modal-body" v-if="doctor">  
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-5">    
                                            <img :src="doctor.dimage" v-if="doctor.dimage" width="200">
                                        </div> <!-- end col -->
                                        <div class="col-lg-7"> 
                                            <!-- Product title -->
                                            <div class="col-md-12">
                                                <h3 class="mt-0">{{doctor.name}}  </h3>  
                                                <table class="table table-responsive">
                                                    <tr>
                                                        <td>Designation: </td>
                                                        <td>{{ doctor.designation }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Qualification: </td>
                                                        <td>{{ doctor.qualification }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Specialist: </td>
                                                        <td>{{ doctor.specialist }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Department: </td>
                                                        <td>{{ doctor.department_id }}</td>
                                                    </tr>
                                                </table>
                                            </div>  

                                        </div> <!-- end col -->
                                    </div> <!-- end row-->
                                    <div class="table-responsive mt-4">
                                        <table class="table table-bordered table-centered mb-0"> 
                                            <tbody>
                                                <tr>
                                                    <td>Phone</td>
                                                    <td>{{ doctor.phone }}</td> 
                                                </tr> 
                                                <tr>
                                                    <td>Email</td>
                                                    <td>{{ doctor.email }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Gender</td>
                                                    <td>{{ doctor.gender }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Date of Birth</td>
                                                    <td>{{ doctor.dob }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Blood Group</td>
                                                    <td>{{ doctor.blood_group }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Status</td>
                                                    <td>
                                                    <span class="badge bg-success" v-if="doctor.status">Active</span> 
                                                    <span class="badge bg-danger" v-else>Inactive</span> 
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td>Description</td>
                                                    <td>{{ (doctor.description != 'null') ?  doctor.description : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Address 1</td>
                                                    <td>{{ (doctor.address_primary != 'null') ? doctor.address_primary : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Address 2</td>
                                                    <td>{{ (doctor.address_secondary != 'null') ? doctor.address_secondary : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Facebook URL</td>
                                                    <td>{{ (doctor.facebook_url != 'null') ? doctor.facebook_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Twitter URL</td>
                                                    <td>{{ (doctor.twitter_url != 'null') ? doctor.twitter_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Instagram URL</td>
                                                    <td>{{ (doctor.instagram_url != 'null') ? doctor.instagram_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Linkedin URL</td>
                                                    <td>{{ (doctor.linkedin_url != 'null') ? doctor.linkedin_url : '' }}</td> 
                                                </tr>
                                                
                                            </tbody>
                                            </table>
                                        </div> 
                                    <div class="col-md-12"> 
                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            
                                        </div>
                                    </div>
                                    </div>
                                </div> <!-- end card-body-->
                            </div> <!-- end card-->
                        </div> <!-- end col-->  
                    </div>
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Doctor',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            isSubmit: false,
            modalShow: false,
            editMode:false,
            disabled: false,
            disabled_upload: false,
            modalActive:false,
            importModal: false,
            errors: {},
            imagePreview:'',
            btn:'Create',
            items: [],
            doctors: [],
            doctor: "",
            departments: [],
            districts: [],
            areas: [],
            loading: true,
            companies: [],
            form: new Form({
                id: '',
                doctor_code: '', 
                company_id: 0, 
                department_id: "", 
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                designation: '',
                qualification: '',
                specialist: '',
                dob: '',
                blood_group: '',
                gender: 'male',
                status: 1,
                create_user: 0,
                password: '',
                password_confirmation: '',
                commission_percentage: '',
                description: '',
                dimage: '',
                address_primary: '',
                address_secondary: '',
                district_id: '0',
                area_id: '0',
                postal_code: '',

                facebook_url: '',
                twitter_url: '',
                instagram_url: '',
                linkedin_url: '',

                doctor_commission_account: '',
            }),
            importFile: '',
            samplefile_url: this.baseUrl+'/import_excel_demo/customers.xlsx',
            multiclasses: { 
              clear: '',
              clearIcon: '', 
            }, 
            columns: [ 
                {
                    label: 'SL',
                    name: '',  
                    isSearch: false, 
                    isAction: true,         
                    width: '5%'
                },   
                {
                    label: 'Code',
                    name: 'doctor_code',           
                    width: '10%'
                },   
                {
                    label: 'Name',
                    name: 'name',
                    width: '15%'
                },
                {
                    label: 'Phone',
                    name: 'phone',
                    width: '10%'
                },
                {
                    label: 'Email',
                    name: 'email',
                    width: '10%'
                },
                {
                    label: 'Specialist',
                    name: 'specialist',
                    width: '10%'
                },
                {
                    label: 'Department',
                    name: 'department_id',
                    width: '15%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '5%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 2,
                dir: 'asc',
                sortKey: 'name', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() { 
        this.getDoctorList();
        // this.fetchIndexData();
        this.fetchCompany()
        this.fetchDistrict()
        this.fetchArea();
        this.fetchDepartments();
    },
    methods: { 
        toggleImportModal: function() {
            this.importModal = !this.importModal;
            this.importFile = '';
            this.$refs.file.value=null;
            this.disabled_upload = true;
            this.errors = '';
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
        },
         
        toggleProfileModal: function() {  
          this.modalShow = !this.modalShow;
        },

        fetchIndexData() { 
            axios.get(this.apiUrl+'/hm/doctors', this.headerjson)
            .then((res) => {
                this.items = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        }, 
        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 
        
        fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                // this.departments = res.data.data; 
                this.departments = [{label: "Select Department", value: ""}];
                res.data.data.map((item) => {
                    this.departments.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 
        fetchDistrict() { 
            axios.get(this.apiUrl+'/districts', this.headerjson)
            .then((res) => {
                this.districts = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },
        fetchArea() { 
            axios.get(this.apiUrl+'/areas',this.headerjson)
            .then((res) => {
                this.areas = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        }, 
        
        customerImportFile() {
            this.importFile = this.$refs.file.files[0];
            if(this.importFile != '') {
                this.errors = ''
            }
        },

        checkImportRequiredPrimary() {
            if(this.$refs.file.value != "") {
                this.disabled_upload = false;
            }else{
                this.disabled_upload = true;
            }
        },

        // Ledger Account Name Setup
        ledgerAccountNameSetup: function(value) {
            if(value != '') {
                this.form.doctor_commission_account = 'Provision for '+value;
            }else{
                this.form.doctor_commission_account = '';
            }
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item);  
            this.form.create_user = 0;
            this.form.doctor_commission_account = item.doctor_commission_account != null ? item.doctor_commission_account : 'Provision for '+item.first_name;
            
        },

        show: function(item) {     
          axios.get(this.apiUrl+'/hm/doctors/'+item.id, this.headers).then(res => {
              if(res.status == 200){  
                this.doctor = res.data.data
                this.modalShow = !this.modalShow;  
              }else{
                this.$toast.error(res.data.message);
              }
              console.log(res.data.data)
          }).catch(err => {  
              this.$toast.error(err.response.data.message);
              if(err.response.status == 422){
                  this.errors = err.response.data.errors 
              }
          }) 
        },
        checkForm: function(e) {

        },
        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();              
            // formData.append('doctor_code', this.form.doctor_code);
            formData.append('company_id', this.form.company_id);
            formData.append('department_id', this.form.department_id);
            formData.append('first_name', this.form.first_name);
            formData.append('last_name', this.form.last_name);
            formData.append('email', this.form.email);
            formData.append('phone', this.form.phone);
            formData.append('designation', this.form.designation);
            formData.append('qualification', this.form.qualification);
            formData.append('specialist', this.form.specialist);
            formData.append('dob', this.form.dob);
            formData.append('blood_group', this.form.blood_group);
            formData.append('gender', this.form.gender);
            formData.append('status', this.form.status);
            formData.append('create_user', this.form.create_user);
            formData.append('password', this.form.password);
            formData.append('password_confirmation', this.form.password_confirmation);
            formData.append('commission_percentage', this.form.commission_percentage);
            formData.append('description', this.form.description);
            formData.append('address_primary', this.form.address_primary);
            formData.append('address_secondary', this.form.address_secondary);
            formData.append('district_id', this.form.district_id);
            formData.append('area_id', this.form.area_id);
            formData.append('postal_code', this.form.postal_code);
            formData.append('facebook_url', this.form.facebook_url);
            formData.append('twitter_url', this.form.twitter_url);
            formData.append('instagram_url', this.form.instagram_url);
            formData.append('linkedin_url', this.form.linkedin_url);
            formData.append('doctor_commission_account', this.form.doctor_commission_account);

            if(this.editMode){
                formData.append('_method', 'put');
                if(this.imagePreview){
                    this.form.dimage ? formData.append('dimage', this.form.dimage, this.form.dimage.name) : '';
                } 
                var postEvent = axios.post(this.apiUrl+'/hm/doctors/'+this.form.id, formData, this.headers);
            }else{  
                this.form.dimage ? formData.append('dimage', this.form.dimage, this.form.dimage.name) : '';
                var postEvent = axios.post(this.apiUrl+'/hm/doctors', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.getDoctorList();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        submitImportForm: function(e) {  
            // this.isSubmit = true;
            // this.disabled_upload = true;
            // const formData = new FormData();
            // formData.append("excel_file", this.importFile);
                    
            // var postEvent = axios.post(this.apiUrl+'/customers/customerBulkUpload', formData, this.headers);

            // postEvent.then(res => {
            //     this.isSubmit = false;
            //     this.disabled_upload = false;
            //     if(res.status == 200){
            //         this.importFile = '';
            //         this.disabled_upload = true;
            //         this.toggleImportModal();
            //         this.fetchIndexData();
            //         this.getDoctorList();
            //         this.$toast.success(res.data.message); 
            //     }else{
            //         this.$toast.error(res.data.message);
            //     }
            // }).catch(err => { 
            //     this.isSubmit = false; 
            //     this.importFile = '';
            //     this.$refs.file.value=null;
            //     this.disabled_upload = true;
            //     this.$toast.error(err.response.data.message);
            //     if(err.response.status == 422){
            //         this.errors = err.response.data.errors 
            //     }
            // });
        },

        onImageChange(e) {
            this.form.dimage = e.target.files[0]
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;  
            
            this.createImage(files[0]);

        },
        createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => { 
                vm.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            this.checkImportRequiredPrimary();
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this doctor!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/doctors/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.getDoctorList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        // For Pagination 
        getDoctorList(url = this.apiUrl+'/hm/doctors/list') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.doctors = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getDoctorList();
        },
        setPage(data){  
            this.getDoctorList(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 900px
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>